/**
 * ap-brand-products.js
 * Populates "More from this brand" blocks (sections/ap-two-column.liquid +
 * snippets/ap-two-column-block.liquid) with up to 4 random products that
 * share the current product's `type`. Data comes from the predictive search
 * suggest endpoint, filtered with Shopify's `product_type:` search syntax,
 * since that's the only storefront API that can list products by type
 * without a dedicated collection per brand.
 */
(function () {
  function formatMoney(cents, format) {
    var formatString = format || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = parts[0];

    return formatString
      .replace('{{amount}}', withDecimals)
      .replace('{{amount_no_decimals}}', noDecimals);
  }

  // Seed tied to a 48h time bucket so the shuffle is deterministic within a
  // 2-day window (stable for crawlers) and only rotates afterwards.
  var _seed = (Math.floor(Date.now() / 172800000) + 3) >>> 0;
  function _rnd() {
    _seed = _seed + 0x6D2B79F5 | 0;
    var t = Math.imul(_seed ^ _seed >>> 15, 1 | _seed);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  }

  function shuffle(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(_rnd() * (i + 1));
      var tmp = array[i];
      array[i] = array[j];
      array[j] = tmp;
    }
    return array;
  }

  function resizeImage(url, width) {
    if (!url) return url;
    return url.replace(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i, '_' + width + 'x.$1$2');
  }

  function buildCard(template, product, moneyFormat, badgeSource) {
    var card = template.content.firstElementChild.cloneNode(true);

    var link = card.classList.contains('ap-brand-card') ? card : card.querySelector('.ap-brand-card');
    link.href = product.url;

    var image = card.querySelector('.ap-brand-card__image');
    var imageUrl = (product.featured_image && product.featured_image.url) || product.image;
    image.src = resizeImage(imageUrl, 400);
    image.alt = (product.featured_image && product.featured_image.alt) || product.title;

    var badges = card.querySelector('.ap-brand-card__badges');
    var tags = product.tags || [];
    badgeSource.querySelectorAll('[data-tag]').forEach(function (icon) {
      if (tags.indexOf(icon.getAttribute('data-tag')) === -1) return;
      badges.appendChild(icon.cloneNode(true));
    });

    card.querySelector('.ap-brand-card__title').textContent = product.title;
    card.querySelector('.ap-brand-card__price').textContent = formatMoney(
      Math.round(parseFloat(product.price) * 100),
      moneyFormat
    );

    return card;
  }

  function init(container) {
    var productType = container.getAttribute('data-product-type');
    var excludeId = container.getAttribute('data-exclude-id');
    var moneyFormat = container.getAttribute('data-money-format');
    var grid = container.querySelector('[data-ap-brand-grid]');
    var template = container.querySelector('[data-ap-brand-card-template]');
    var badgeSource = container.querySelector('.ap-brand-card__badges-source');

    if (!productType || !grid || !template || !badgeSource) return;

    var url = '/search/suggest.json?q=' + encodeURIComponent('product_type:' + productType) +
      '&resources[type]=product&resources[limit]=10';

    fetch(url)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var products = ((data.resources && data.resources.results && data.resources.results.products) || [])
          .filter(function (product) { return String(product.id) !== excludeId; });

        if (!products.length) return;

        shuffle(products).slice(0, 4).forEach(function (product) {
          grid.appendChild(buildCard(template, product, moneyFormat, badgeSource));
        });

        container.removeAttribute('hidden');
      })
      .catch(function () {});
  }

  document.querySelectorAll('[data-ap-brand-products]').forEach(init);
})();
